<template>
  <VDialog v-model="isShowModal" max-width="700">
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-file" class="mr-2" />
        View Receipt
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleClose()" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VCardText>
          <div v-if="isLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
            <VProgressCircular indeterminate color="primary" />
          </div>
          <div v-else class="w-100">
            <div v-html="receiptHtml"></div>
            <!-- <iframe :srcdoc="receiptHtml" frameborder="0" width="100%" height="400px"></iframe> -->
          </div>
          <VCol cols="12">
            <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleClose()">Cancel</VBtn>
          </VCol>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import applicationService from '@/services/application-service/application.service';
//Text
import { errorViewReceiptText } from '@/text/snackbarsText';
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    receiptId: String
  },
  data() {
    return {
      isLoading: true,
      receiptHtml: ''
    };
  },
  computed: {
    isShowModal() {
      if (this.modelValue) this.getReceipt();
      return this.modelValue;
    }
  },
  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async getReceipt() {
      if (!this.receiptId) return;
      this.isLoading = true;
      this.receiptHtml = '';

      try {
        const { receipt } = await applicationService.getReceipt({
          id: this.receiptId
        });
        // console.log(receipt);
        this.receiptHtml = receipt;
      } catch (err) {
        this.showSnackbar({ text: errorViewReceiptText, color: 'red' });
        this.handleClose();
      } finally {
        this.isLoading = false;
      }
    },

    handleClose() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>
